// extracted by mini-css-extract-plugin
export var dropdown = "_sk-0";
export var imageWrapper = "_sk-3";
export var itemNameContainer = "_sk-1";
export var productImage = "_sk-2";
export var spinnerWrapper = "_sk-4";